// ACCOUNT SUBSCRIPTION — CURRENT *****************************************************************
// pathname: /v1/account-subscriptions/current
// method:   GET
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi/useSwrApi';
import type { ApiSchema } from '@type/api/apiUtilityFn';

export type AccountSubscription = ApiSchema<'AccountSubscriptionRead'>;

interface UseSwrAccountSubscriptionProps {
  locale?: string;
  shouldFetch?: boolean;
}

/**
 * @description SWR: the logged account's subscription.
 *
 * Responds 200 with a `null` body when the account has no subscription — that is the
 * normal answer, not an error, so `data` being nullish means "not subscribed" rather
 * than "not loaded". Check `isLoading` to tell the two apart.
 */
export const useSwrAccountSubscription = (props?: UseSwrAccountSubscriptionProps) => {
  const { locale, shouldFetch = true } = props ?? {};

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<AccountSubscription | null>({
    url: '/v1/account-subscriptions/current',
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
    },
  });

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};
